import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LinkButtonComponent } from './link-button.component';
import { DssButtonModule } from '@dss/components/button';
import { TrackingModule } from '../../../../shared/directives/tracking.module';
@NgModule({
  declarations: [LinkButtonComponent],
  imports: [
    CommonModule,
    DssButtonModule,
    TrackingModule
  ],
  exports:[LinkButtonComponent]
})
export class LinkButtonModule { }
